import CrudBase from '../../../CrudBase';
import axios from '../../../../axios-common';

class CommissionApi extends CrudBase {

  getCommission = (date, params) => axios.get(`${this.endpoint}/get-by?date=${date}`, params);

  defaultMethods = {
    getCommission: this.getCommission,
  }
};

const acompanhamento = new CommissionApi('api/v1/commission');

export default acompanhamento.defaultMethods;
